import { FC, ReactNode } from 'react';
import { Popover } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';

import { Text } from 'shared/components/Text';
import classes from './styles.module.scss';
import './popover.scss';

export interface IContent {
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  label: string;
  key: string;
  onClick?: () => void | undefined;
}
export interface IPopOverProps {
  title?: string;
  content: IContent[];
  placement?: TooltipPlacement | undefined;
  children?: ReactNode;
  trigger: string;
  IconPositionRight?: boolean;
}

export const BasicPopOver: FC<IPopOverProps> = ({
  title,
  content,
  placement,
  children,
  trigger
}) => {
  const getPopupContainer = (triggerNode: HTMLElement) => {
    return triggerNode.parentElement || document.body;
  };

  return (
    <Popover
      title={title}
      placement={placement}
      overlayClassName={'popover'}
      content={content.map(({ key, label, iconLeft, iconRight, onClick }) => {
        return (
          <Text
            type={'sf-caption'}
            key={key}
            onClick={onClick}
            className={classes.options}
          >
            {iconLeft}
            {label}
            {iconRight}
          </Text>
        );
      })}
      trigger={trigger}
      getPopupContainer={getPopupContainer}
    >
      {children}
    </Popover>
  );
};
